let activeSession = null;
let permissionDenied = false;
const permissionDeniedListeners = [];
function getSpeechRecognitionConstructor() {
    if (typeof window !== 'undefined') {
        return window.SpeechRecognition || window.webkitSpeechRecognition || null;
    }
    return null;
}
function setPermissionDenied() {
    if (permissionDenied)
        return;
    permissionDenied = true;
    permissionDeniedListeners.forEach(fn => fn());
}
if (typeof navigator !== 'undefined' && navigator.permissions) {
    navigator.permissions.query({ name: 'microphone' }).then((status) => {
        if (status.state === 'denied') {
            setPermissionDenied();
        }
        status.onchange = () => {
            if (status.state === 'denied') {
                setPermissionDenied();
            }
        };
    }).catch(() => { });
}
export function isSpeechRecognitionSupported() {
    return !permissionDenied && getSpeechRecognitionConstructor() !== null;
}
export function onSpeechRecognitionPermissionDenied(listener) {
    if (permissionDenied) {
        listener();
        return;
    }
    permissionDeniedListeners.push(listener);
}
export function startSpeechRecognition(consumerId, callbacks) {
    if (activeSession) {
        const prev = activeSession;
        activeSession = null;
        try {
            prev.recognition.abort();
        }
        catch (_) { }
        prev.callbacks.onEnd();
    }
    const SRConstructor = getSpeechRecognitionConstructor();
    if (!SRConstructor) {
        callbacks.onError('not-supported');
        return;
    }
    const recognition = new SRConstructor();
    recognition.continuous = true;
    recognition.interimResults = true;
    recognition.lang = navigator.language || 'en-US';
    activeSession = { consumerId, recognition, callbacks };
    recognition.onresult = (event) => {
        if (!activeSession || activeSession.consumerId !== consumerId)
            return;
        let interimTranscript = '';
        let finalTranscript = '';
        for (let i = event.resultIndex; i < event.results.length; i++) {
            const result = event.results[i];
            if (result.isFinal) {
                finalTranscript += result[0].transcript;
            }
            else {
                interimTranscript += result[0].transcript;
            }
        }
        if (finalTranscript) {
            callbacks.onResult(finalTranscript, true);
        }
        if (interimTranscript) {
            callbacks.onResult(interimTranscript, false);
        }
    };
    recognition.onerror = (event) => {
        if (!activeSession || activeSession.consumerId !== consumerId)
            return;
        if (event.error === 'not-allowed') {
            setPermissionDenied();
        }
        activeSession = null;
        callbacks.onError(event.error);
        callbacks.onEnd();
    };
    recognition.onend = () => {
        if (!activeSession || activeSession.consumerId !== consumerId)
            return;
        activeSession = null;
        callbacks.onEnd();
    };
    try {
        recognition.start();
    }
    catch (_) {
        activeSession = null;
        callbacks.onError('start-failed');
        callbacks.onEnd();
    }
}
export function stopSpeechRecognition(consumerId) {
    if (!activeSession)
        return;
    if (consumerId && activeSession.consumerId !== consumerId)
        return;
    // Don't clear activeSession here. recognition.stop() will deliver
    // a final onresult (committing pending speech) followed by onend,
    // which clears activeSession and calls callbacks.onEnd().
    try {
        activeSession.recognition.stop();
    }
    catch (_) { }
}
export function isSpeechRecognitionActive(consumerId) {
    if (!activeSession)
        return false;
    if (consumerId)
        return activeSession.consumerId === consumerId;
    return true;
}
